import React from "react";
import { withRedux, getTextColor } from "helpers";
import * as styles from "../../../newStyles.styles";
import styled, { css } from "react-emotion";
import { Hr } from "appStyles";
import { Locations } from "components";
import SocialMediaLinks from "./SocialMediaLinks";

const PageContainer = styled("div")`
  padding: 0.1em;
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : "white"};
  border-radius: 0px 0px 5px 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  @media only screen and (min-width: 500px) {
    padding: 1em;
  }
`;

const image = css`
  width: 100%;
  height: 175px;
  border-radius: 5px 5px 0px 0px;
  box-shadow: 3px 0px 13px rgba(120, 120, 120, 0.5);
  object-fit: fill;
  @media only screen and (min-width: 768px) {
    height: 250px;
  }
`;

const EmailButton = styled("button")`
  width: 200px;
  padding: 10px;
  margin: auto;
  border-radius: 30px;
  margin-bottom: 5px;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`;

function AboutUsWebComponent(props) {
  const {
    activeApp,
    business,
    activeTemplate: { backgroundColor },
  } = props;
  const {
    links,
    mainImageLink,
    business: { email, name, locations },
    view,
    website,
  } = activeApp;

  const textColour = getTextColor(backgroundColor);

  const navBarColor = view.navigation.navBarColor;

  return (
    <div>
      {mainImageLink && (
        <img src={mainImageLink} className={image} alt={"contact-us-image"} />
      )}
      <PageContainer backgroundColor={backgroundColor}>
        <styles.H4 style={{ margin: "20px 0px 20px", color: textColour }}>
          {name}
        </styles.H4>
        <EmailButton
          style={{
            color: textColour,
            border: "1px " + textColour + " solid",
            backgroundColor: backgroundColor,
          }}
        >
          <a
            href={"mailto:" + email}
            style={{
              color: textColour,
              textDecoration: "none",
            }}
          >
            Email
          </a>
        </EmailButton>
        <EmailButton
          style={{
            color: textColour,
            border: "1px " + textColour + " solid",
            backgroundColor: backgroundColor,
            marginTop: "10px",
          }}
        >
          <a
            href={website}
            style={{
              color: textColour,
              textDecoration: "none",
            }}
            target="_blank"
          >
            Website
          </a>
        </EmailButton>
        <Hr style={{ width: "100%", margin: "20px 0px" }} />
        <Locations locations={locations} color={textColour} />
        <styles.H5 style={{ margin: "20px 0px 20px", color: textColour }}>
          Follow Us!
        </styles.H5>
        <SocialMediaLinks links={links} />
      </PageContainer>
    </div>
  );
}

export default withRedux(AboutUsWebComponent);
